module.exports = __webpack_public_path__ + "img/ic-plus-gray.cfe2e8cc.svg";